import * as React from 'react';
import { cn } from '../../lib/cn';

export interface CheckboxProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'type' | 'onChange' | 'checked'
> {
  checked?: boolean | 'indeterminate';
  onCheckedChange?: (checked: boolean) => void;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, checked, onCheckedChange, ...props }, ref) => {
    const innerRef = React.useRef<HTMLInputElement | null>(null);
    const setRef = React.useCallback(
      (el: HTMLInputElement | null) => {
        innerRef.current = el;
        if (typeof ref === 'function') ref(el);
        else if (ref !== null) Object.assign(ref, { current: el });
      },
      [ref],
    );
    React.useEffect(() => {
      if (innerRef.current)
        innerRef.current.indeterminate = checked === 'indeterminate';
    }, [checked]);
    const isChecked = checked === true;
    const isControlled = checked !== undefined;
    return (
      <input
        type="checkbox"
        ref={setRef}
        {...(isControlled && {
          checked: checked === 'indeterminate' ? false : checked,
        })}
        onChange={(e) => onCheckedChange?.(e.target.checked)}
        className={cn(
          'nv-checkbox appearance-none',
          isChecked && 'is-checked',
          className,
        )}
        {...props}
      />
    );
  },
);
Checkbox.displayName = 'Checkbox';
